import { VisualElement, VisualElementsClient } from 'api/clients/VisualElementClient'
import { useEffect } from 'react'
import { Categories } from './Categories'
import { IFilters } from 'components/Wizards/DesignWizard/TemplateSelection/Filters'
import { HeadingLevel } from 'blaze-ui/Heading/Heading'
import { compact } from 'lodash'

export const ITEM_WIDTH = 113
export const LARGE_ITEM_WIDTH = 256
export const ITEM_HEIGHT = 104
export const LARGE_ITEM_HEIGHT = 256
export const WIDE_ASPECT_RATIO = 1.5

interface Props {
  onChange?: (template?: VisualElement) => any
  filters: IFilters
  headingLevel?: HeadingLevel
  carouselOffset?: number
  width: number
  height: number
  sourceVisualElementId?: number
  setSourceVisualElementId?: (val?: number) => void
  largePreviews?: boolean
}

export const TemplateSelect = ({
  onChange,
  filters,
  headingLevel,
  carouselOffset,
  width,
  height,
  sourceVisualElementId,
  setSourceVisualElementId,
  largePreviews = false,
}: Props) => {
  useEffect(() => {
    if (!sourceVisualElementId) {
      onChange?.(undefined)
      return
    }
    const fetchTemplate = async () => {
      const res = await VisualElementsClient.getElement(sourceVisualElementId)
      if (res.type === 'success') {
        onChange?.(res.data)
      }
    }
    fetchTemplate()
  }, [sourceVisualElementId]) // eslint-disable-line react-hooks/exhaustive-deps

  const handleSelect = (id: number) => {
    if (sourceVisualElementId === id) {
      setSourceVisualElementId?.(undefined)
    } else {
      setSourceVisualElementId?.(id)
    }
  }

  return (
    <Categories
      width={width}
      height={height}
      filters={filters}
      onSelect={handleSelect}
      selectedIds={compact([sourceVisualElementId])}
      largePreviews={largePreviews}
      headingLevel={headingLevel}
      carouselOffset={carouselOffset}
    />
  )
}
